export default __webpack_public_path__ + "static/media/instructions.659042d3.png";